import withSplitting from 'components/hoc/withSplitting'
export default withSplitting(
  () => import('./CreateExclusiveAccountContainer'),
  {
    componentName: 'CreateExclusiveAccountContainer'
  }
)
